import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { ChangeLog } from "../../resources";

export interface HistoryServiceFilters {
  pageSize?: number;
  page?: number;
  search?: string;
}

@Injectable()
export class HistoryService extends BaseDataService<ChangeLog> {
  constructor(http: HttpService) {
    super(http, "history");
  }

  createInstance(options: any): ChangeLog {
    return new ChangeLog(options);
  }

  filterBy(filters: HistoryServiceFilters) {
    return this.all(filters);
  }
}
